<template>
	<wrapper>
		<template slot="wrapper">
			<div class="o-shell">
				<app-header />

				<main class="o-main">
					<post>
						<template slot="header">
							<h1>
								If every day were a vacation, how would you
								spend your money?
							</h1>
						</template>

						<template slot="content">
							<p>
								This calculator is designed to help you gain a
								realistic understanding of how much you will
								need to save for retirement. While this exercise
								is not the final process in retirement planning…
								we hope it is a useful start!
							</p>

							<router-link to="/calculations" class="c-button"
								>Retirement Calculator</router-link
							>
						</template>

						<template slot="img">
							<img src="~assets/Artwork@2x.png" />
						</template>
					</post>
				</main>
			</div>
		</template>
	</wrapper>
</template>

<script>
import Header from 'components/header/header.vue';
import Article from 'components/article/Article.vue';
import Button from 'components/button/button.vue';
import Wrapper from 'components/wrapper/Wrapper.vue';

export default {
	components: {
		'app-header': Header,
		post: Article,
		btn: Button,
		wrapper: Wrapper,
	},
};
</script>
